module.exports = __webpack_public_path__ + "img/milos.f2f700b6.jpg";